module.exports = __webpack_public_path__ + "549e7ddd8b6ed502a95847e5b95d2013.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-1024-7.jpg
// module id = 435
// module chunks = 0